// import {actions} from "../constants/app_constants.js";
import { authenticationService } from "../services/authenticationService.js";
import i18n from '../utils/localizations.jsx';
import { utils } from "../utils/utils";
import { post as postAx, get as getAx} from 'axios';

const get = async(url) => await call("GET", url);
const del = async(url) => await call("DELETE", url);
const post = async(url, content) => await call("POST", url, content);

const call = async (method, apiUrl, content) => {
    const headers = new Headers();
    if (content) {
        headers.append('Content-Type', 'application/json');
    }
    
    headers.append('l', i18n.language);
    headers.append('Authorization', 'Bearer ' + authenticationService.getCurrentUser().token);
    const requestOptions = {
        method: method,
        headers,
        body: content ? JSON.stringify(content) : null
    };
    const request = new Request(apiUrl, requestOptions);
    let response = await fetch(request);

    if (!response.ok) {
        if ([401, 403].indexOf(response.status) !== -1) {
            authenticationService.logout();
            //location.reload(true);
        }

        const error = (await response.json()) || response.status;
        throw new Error(error);
    }

    try {
        let contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const data = await response.json();
            return data;
        } else {
            const data = await response.text();
            return data ? data : "";
        }
    } catch (error) {
        throw new Error(error);
    }
}


async function getReport(method, apiUrl, content) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('l', i18n.language);
    headers.append('Authorization', 'Bearer ' + authenticationService.getCurrentUser().token);
    const requestOptions = {
        method: method,
        headers,
        body: content ? JSON.stringify(content) : null
    };
    const request = new Request(apiUrl, requestOptions);
    let response = await fetch(request);

    if (!response.ok) {
        if ([401, 403].indexOf(response.status) !== -1) {
            authenticationService.logout();
            //location.reload(true);
        }

        const error = (await response.json()) || response.statusCode;
        throw new Error(error);
    }

    const data = await response.text();
    const blob = new Blob([utils.base64toBlob(data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')], {});
    return blob;
}

async function downloadFile(apiUrl) {
    const config = {
        headers: {
            'Authorization': 'Bearer ' + authenticationService.getCurrentUser().token,
            'l': i18n.language
        },
        responseType: 'blob'
    };

    const response = await getAx(apiUrl, config);
    console.log(response);
    if (response.status !== 200) {
        if (response.status === 401 || response.status === 403) {
            authenticationService.logout();

        }
        let error = response.data;
        throw new Error(error);
    }
    let fileResponse = {
        file: new Blob([response.data]),
        fileName: response.headers['content-disposition'].split('filename=')[1].split(';')[0].trim()
    }
    return fileResponse;
}

async function uploadFile(apiUrl, file) {
    let formData = new FormData();
    formData.append("file", file);
    const config = {
        headers: {
            'content-type': 'multipart/form-data',
            'Authorization': 'Bearer ' + authenticationService.getCurrentUser().token,
            'l': i18n.language
        },
    };

    let response = await postAx(apiUrl, formData, config);
    console.log(response);
    if (response.status !== 200) {
        if (response.status === 401 || response.status === 403) {
            authenticationService.logout();            
        }
        let error = response.data;
        throw new Error(error);
    }
    return response.data;
}

export const httpClient =
{
    get,
    post,
    del,
    call,
    getReport,
    downloadFile,
    uploadFile
}